// import styles from './../../src/abstracts/_borders.scss';
const styles = {
  borderS: 1,
  borderM: 2,
  borderL: 3,
  border0: 0,
  borders: { '0': 0, s: 1, m: 2, l: 3 },
  borderRS: 2,
  borderRM: 3,
  borderRL: 6,
  borderR100: 100,
  borderRPill: 1000,
  borderR0: 0,
  bordersR: { '0': 0, '100': 100, s: 2, m: 3, l: 6, pill: 1000 }
}
export const bordersR = styles.bordersR;

export default styles.borders;